import React, { useEffect } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Eye, Edit as EditIcon } from "../../styled/AllImages";
import { BsTrash } from "react-icons/bs";
import { ButtonStyled } from "../../styled/Elements";

const TableComponents = ({
  send,
  onView,
  onMore,
  onEdit,
  onSetting,
  onDelete,
  options,
  index,
  Edit,
  onButton,
  type,
  updateStatus,
  list,
  onClick,
  onViewListings,
}) => {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <TableComponentsWrapper className="d-flex list-unstyled d-flex align-items-center mb-0 actionsList">
      {options?.includes("more") && (
        <li className="me-1">
          <ButtonStyled label={t("more")} bg="var(--themeColorSecondary)" onClick={() => onMore(list?.id)} />
        </li>
      )}
      {options?.includes("view") && (
        <li className="me-1">
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{t("view")}</Tooltip>}
          >
            <Eye cursor="pointer" width="20px" onClick={() => {
              onView(list?.id);
              onClick && onClick(list?.hash_id ? list?.hash_id : list?.id);
              window.scrollTo(0, 0)
            }
              } />
          </OverlayTrigger>
        </li>
      )}

      {options?.includes("edit") && (
        <li>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{t("edit")}</Tooltip>}
          >
            <Link
              to={Edit ? `/${Edit}/${index}` : "#"}
              {...(onEdit && { onClick: onEdit })}
              type="button"
              className="border-0 bg-transparent text-decoration-none"
            >
              <EditIcon width="20px" />
            </Link>
          </OverlayTrigger>
        </li>
      )}

      {options?.includes("status") && (
        <li className="me-1 mb-1">
          <OverlayTrigger
            placement="top"
            overlay={
              !options?.includes("listings") ? (
                <Tooltip>{t("listing_status")}</Tooltip>
              ) : (
                <Tooltip>{t("user_status")}</Tooltip>
              )
            }
          >
            <Form.Check
              type="switch"
              checked={list?.status == 1}
              onChange={() =>
                updateStatus(list?.id, list?.status == 1 ? 0 : 1)
              }
              className="custom-switch"
            />
          </OverlayTrigger>
        </li>
      )}

      {options?.includes("delete") && (
        <li>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{t("delete")}</Tooltip>}
          >
            <button
              type="button"
              onClick={() => onDelete(list?.id)}
              className="border-0 bg-transparent"
            >
              <BsTrash width="20px" />
            </button>
          </OverlayTrigger>
        </li>
      )}
    </TableComponentsWrapper>
  );
};

export default TableComponents;

const TableComponentsWrapper = styled.ul`
  .custom-switch .form-check-input {
    cursor: pointer !important;
    width: 42px !important;
    height: 20px !important;
  }

  .custom-switch .form-check-input:checked {
    background-color: #0dcaf0 !important;
    border-color: #0dcaf0 !important;
  }
`;
